export const experiencesFr = [
    {
        title: "Dévloppeur en freelance",
        company: 'Scotfy, Lyon, Fr',
        period: "2020 - 2021 (2 mois)",
        technologies: 'C#, .NET, Angular 11, Angular Materials, pgSql, Qlik Sense',
        missions: [
            "Mise en place d'un gestionnaire de thèmes (couleurs, logo).",
            "Mise en place d'un gestionnaire de dossiers virtuels qui peuvent contenir des apps Qlik Sense.",
            "Développement d'une interface de sauvegarde des ressources.",
            "Création de pages web personnalisables : Qlik Sense Mashups (En cours).",
        ],
        detailIsDisplayed: false,
    },
    {
        title: "Dévloppeur en freelance",
        company: 'AGC Glass Europe, Maubeuge, Fr',
        period: "2020 - 2021 (5 mois)",
        technologies: 'JAVA 8, Spring, Angular 8, Angular Materials, MySql',
        missions: [
            "Développement d'une application de notation de fournisseurs par les acheteurs.",
            "Maintenance évolutive et corrective d'applications.",
        ],
        detailIsDisplayed: false,
    },
    {
        title: "Dévloppeur en alternance",
        company: 'AGC Glass Europe, Maubeuge, Fr',
        period: "2019 - 2020 (1 an)",
        technologies: 'JAVA 8, Spring, Angular 8, Angular Materials, MySql',
        missions: [
            "Application de gestion des camions entrant sur le site",
            "Amélioration d'une application de création de plans de préventions.",
            "Application de mise en forme des commandes du verre, dans l’intérêt d'une meilleure lisibilité des priorités pour les équipes de production.",
            "Création de pages web personnalisables : Qlik Sense Mashups (En cours).",
        ],
        detailIsDisplayed: false,
    },
    {
        title: "Stagiaire Dévloppeur logiciel",
        company: 'Scotfy, Lyon, Fr',
        period: "2018 (3 mois)",
        technologies: 'C#, .NET, Chiffrement AES-256',
        missions: [
            "Multilingue: Mise en place d’un système de gestion de la langue afin de permettre à l’utilisateur de choisir la langue des interfaces, des messages et des logs.",
            "Clé de licence: Validation du logiciel à l’aide d’une clé de licence basée sur le nom d’utilisateur Windows.",
        ],
        detailIsDisplayed: false,
    },
];

